import { render, staticRenderFns } from "./TabelaMatricula.vue?vue&type=template&id=08a23bd0&"
import script from "./TabelaMatricula.vue?vue&type=script&lang=js&"
export * from "./TabelaMatricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports